module.exports = __webpack_public_path__ + "img/ht18.1f99ad9d.png";